// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3Gcrc","text":"SelectPayment_text__dlKEe","title":"SelectPayment_title__8kRrD","btn":"SelectPayment_btn__1_hJJ"};